import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileTextIcon as FileText, ArrowRightIcon as ArrowRight } from "@phosphor-icons/react";

/**
 * Deep-link card replacing the in-Settings KennelDefaultContractCard.
 *
 * Why: Settings → Breeding tab used to host the actual uploader, but
 * breeders kept reporting they couldn't find it. The canonical home is
 * now `/contracts` — this card preserves muscle memory ("I went to
 * Settings to manage my contract template") while routing them to the
 * real surface so the upload, status, and per-puppy signature flow
 * live in one place.
 */
export default function KennelDefaultContractLinkCard() {
  return (
    <div
      className="rounded-2xl border border-[#EAEAEA] bg-white p-5 sm:p-6"
      data-testid="kennel-default-contract-link-card"
    >
      <div className="flex items-start gap-3">
        <span className="p-2 rounded-full bg-[#FBF7EC] shrink-0">
          <FileText size={20} weight="duotone" className="text-gold-dark" />
        </span>
        <div className="flex-1 min-w-0">
          <h3 className="font-spectral text-xl tracking-tight">Sales contracts</h3>
          <p className="text-[12.5px] sm:text-[13px] text-[#3F3F3F] mt-1 leading-snug">
            Upload your kennel default sales-agreement template and manage
            every per-puppy contract in one place. Both sides click-wrap
            sign in the browser — no DocuSign, no printing.
          </p>
          <Link to="/contracts" data-testid="kennel-default-contract-link-cta">
            <Button size="sm" className="mt-3 rounded-full bg-ink hover:bg-crimson text-white">
              Open Contracts hub <ArrowRight size={12} weight="bold" className="ml-1" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
